import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

const IconWrapper = styled(CenteredFlexRow)`
    width: 100%;
    height: 100%;
`;

/**
 * @deprecated Use TextIconCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextIconCell/TextIconCell.tsx}
 */
export const SimpleIconCell: FC<ITableCellProps> = ({ row }) => {
    const {
        iconDetails: { iconName, iconColor = colorsPalettes.carbon[400], iconSize = "xs", tooltip },
    } = row;

    return (
        <IconWrapper>
            <PlainTooltip
                enabled={!!tooltip}
                tooltipContent={tooltip}
            >
                <span>
                    <SWReactIcons
                        iconName={iconName}
                        size={iconSize}
                        iconColor={iconColor}
                    />
                </span>
            </PlainTooltip>
        </IconWrapper>
    );
};
